import * as React from 'react';
import classnames from 'classnames';
import { Paper, Popper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(
  {
    suggestionsContainer: {
      zIndex: 2,
    },
    suggestionsPaper: {
      maxHeight: '50vh',
      overflowY: 'auto',
    },
  },
  { name: 'RaAutocompleteSuggestionList' }
);

const CustomAutocompleteSuggestionList = props => {
  const {
    children,
    className,
    isOpen,
    menuProps,
    inputEl,
    suggestionsContainerProps,
  } = props;
  const classes = useStyles(props);

  return (
    <Popper
      open={isOpen}
      anchorEl={inputEl}
      className={classnames(classes.suggestionsContainer, className)}
      modifiers={{}}
      {...suggestionsContainerProps}
    >
      <div {...(isOpen ? menuProps : {})}>
        <Paper
          square
          style={{
            marginTop: 8,
            minWidth: inputEl ? inputEl.clientWidth : null,
          }}
          className={classes.suggestionsPaper}
        >
          {children}
        </Paper>
      </div>
    </Popper>
  );
};

CustomAutocompleteSuggestionList.propTypes = {
  children: PropTypes.object.isRequired,
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  menuProps: PropTypes.any.isRequired,
  inputEl: PropTypes.element.isRequired,
  classes: PropTypes.any,
  suggestionsContainerProps: PropTypes.any,
};


export default CustomAutocompleteSuggestionList;
